import React from "react";
import { Box, Pagination } from "@mui/material";

type Props = {
  totalItems: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  itemsPerPage?: number;
};

const CustomPagination = ({
  totalItems,
  currentPage,
  onPageChange,
  itemsPerPage = 10,
}: Props) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalPages <= 1) return null;

  return (
    <Box
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 4,
  }}
>
  <Pagination
    count={totalPages}
    page={currentPage}
    onChange={(_, page) => onPageChange(page)}
    shape="circular"
    siblingCount={1}
    boundaryCount={1}
    sx={{
      "& .MuiPagination-ul": {
        alignItems: "center",
        gap: "8px",
      },

      "& .MuiPaginationItem-root": {
        color: "#1F1F1F",
        fontSize: "15px",
        fontWeight: 500,
        minWidth: "30px",
        height: "30px",
      },

      "& .Mui-selected": {
        backgroundColor: "#1976D2 !important",
        color: "#FFFFFF",
        fontWeight: 600,
      },

      "& .MuiPaginationItem-previousNext": {
        color: "#6B7280",
      },

      "& .MuiPaginationItem-icon": {
        fontSize: "24px",
      },
    }}
  />
</Box>
  );
};

export default CustomPagination;